import { CircularProgressbarWithChildren, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';

import './EpProgress.scss';

import useResources from 'hooks/useResources';

interface EpProgressProps {
    isUpdate?: boolean;
    progress?: number;
}

const EpProgress = (props: EpProgressProps) => {
    const { isUpdate, progress } = props;

    const { t } = useResources();

    const progressToShow = isUpdate ? 95 : Math.round(progress || 0);

    return (
        <div className="progress-indicator">
            <CircularProgressbarWithChildren
                value={progressToShow}
                strokeWidth={7}
                styles={buildStyles({
                    pathColor: '#838609',
                    trailColor: '#f6f4ed',
                })}
            >
                {isUpdate ? (
                    <div className="update">{t('newDashboardPage.progressIndicator.update')}</div>
                ) : (
                    <div className="d-flex flex-column align-items-center">
                        <div className="percent">{progressToShow}%</div>
                        <div className="complete">{t('newDashboardPage.progressIndicator.complete')}</div>
                    </div>
                )}
            </CircularProgressbarWithChildren>
        </div>
    );
};

export default EpProgress;
